import React, { useState, useEffect } from "react";
import Header from "../../components/Headers/Header";
import { useSelector, useDispatch } from "react-redux";
import {
  Container,
  Card,
  CardBody,
  Button,
  Row,
  Col,
  Spinner,
  Alert,
  Badge,
} from "reactstrap";
import {
  getGasFeeBalance,
  topUpWallet,
  clearGasFeeErrors,
  refreshAdminToken,
} from "store/actions/gasFeeActions";
import { getTokenInfo, formatTimeUntilExpiry } from "utils/tokenUtils";
import TabsInfoModal from "components/Modal/TabsInfoModal";

function GasFeeMonitor() {
  const dispatch = useDispatch();
  const [tokenInfo, setTokenInfo] = useState(getTokenInfo());
  const [refreshing, setRefreshing] = useState(false);

  const {
    balanceLoading,
    topUpLoading,
    polBalance,
    estimatedTransactions,
    balanceData,
    topUpData,
    error,
  } = useSelector((state) => state.gasFee);

  useEffect(() => {
    dispatch(getGasFeeBalance());
    dispatch(topUpWallet());

    const interval = setInterval(() => {
      setTokenInfo(getTokenInfo());
    }, 30000);

    return () => clearInterval(interval);
  }, [dispatch]);

  return (
    <>
      <Header />
      <Container className="mt-3" fluid>
        <Row className="justify-content-center">
          <Col lg={12}>
            <Card className="shadow">
              <CardBody>
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0">Gas Fee Monitor</h3>
                  </Col>
                </Row>

                {/* Summary Cards */}
                <Row className="no-gutters justify-content-center mt-4">
                  <Col lg={4} md={6} sm={6} xs={12} align="center">
                    <div className="complaint-card">
                      <p className="complaint-card-number mb-1">
                        {balanceLoading ? (
                          <Spinner size="sm" />
                        ) : (
                          `${balanceData?.data?.formattedBalance || 0} POL`
                        )}
                      </p>
                      <p className="complaint-card-text">POL Balance</p>
                    </div>
                  </Col>
                  <Col
                    lg={4}
                    md={6}
                    sm={6}
                    xs={12}
                    align="center"
                    className="mt-3 mt-sm-0"
                  >
                    <div className="complaint-card">
                      <p className="complaint-card-number mb-1">
                        {balanceLoading ? (
                          <Spinner size="sm" />
                        ) : (
                          estimatedTransactions
                        )}
                      </p>
                      <p className="complaint-card-text">
                        Remaining Transactions
                      </p>
                    </div>
                  </Col>
                </Row>

                {/* Balance Details */}
                {balanceData && !balanceLoading && (
                  <Row className="mt-4">
                    <Col>
                      <Card className="p-3">
                        <h4 className="mb-3">Balance Details</h4>
                        <Row>
                          <Col md={6}>
                            <p>
                              <strong>Current Balance:</strong>{" "}
                              {balanceData.data?.formattedBalance || 0} POL
                            </p>
                            <p>
                              <strong>Estimated Transactions:</strong>{" "}
                              {balanceData.estimatedTransactions || 0}
                            </p>
                          </Col>
                          <Col md={6}>
                            <p>
                              <strong>Balance:</strong>{" "}
                              {balanceData.data?.balance || 0} Wei
                            </p>
                          </Col>
                        </Row>
                      </Card>
                    </Col>
                  </Row>
                )}

                {topUpData && !topUpLoading && (
                  <Row className="mt-4">
                    <Col>
                      <Card className="p-3">
                        <h4 className="mb-3">Top Up Data</h4>
                        <Row>
                          <Col md={6}>
                            <p>
                              <strong>Native POL Balance:</strong>{" "}
                              {topUpData.data?.balances?.native_pol || 0} POL
                            </p>
                            <p>
                              <strong>Last Updated:</strong>{" "}
                              {topUpData.timestamp
                                ? new Date(topUpData.timestamp).toLocaleString()
                                : "N/A"}
                            </p>
                          </Col>
                          <Col md={6}>
                            <p>
                              <strong>My Token Balance:</strong>{" "}
                              {topUpData.data?.balances?.my_token || 0}
                            </p>
                          </Col>
                        </Row>
                      </Card>
                    </Col>
                  </Row>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default GasFeeMonitor;
